<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <h2>赛事管理系统</h2>
        <p>管理员登录</p>
      </div>

      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="account">用户名</label>
          <input
              type="text"
              id="account"
              v-model="form.account"
              required
              placeholder="请输入用户名"
          />
        </div>

        <div class="form-group">
          <label for="password">密码</label>
          <input
              type="password"
              id="password"
              v-model="form.password"
              required
              placeholder="请输入密码"
          />
        </div>

        <!-- 验证码部分 -->
        <div class="form-group captcha-group">
          <label for="captcha">验证码</label>
          <div class="captcha-wrapper">
            <input
                type="text"
                id="captcha"
                v-model="form.captcha"
                required
                placeholder="请输入验证码"
                class="captcha-input"
            />
            <img
                :src="captchaSrc"
                alt="验证码"
                class="captcha-img"
                @click="refreshCaptcha"
            />
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="login-btn" :disabled="loading">
            <span v-if="loading">登录中...</span>
            <span v-else>登录</span>
          </button>
        </div>

        <div class="error-message" v-if="errorMsg">{{ errorMsg }}</div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { getImgCode ,signin} from '@/api/website';

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const form = ref({
  account: '',
  password: '',
  captcha: '',
  key: ''
})
const loading = ref(false)
const errorMsg = ref('')
const captchaSrc = ref('')


// 修改 refreshCaptcha 函数
const refreshCaptcha = async () => {
  try {
    form.value.captcha ='';
    // 生成唯一的 key 值
    const uniqueKey = `captcha_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    form.value.key = uniqueKey
    // 调用 getImgCode 接口，传递动态生成的 key
    const response = await getImgCode({key: form.value.key})

    // 由于后端直接返回图片流，需要构建完整的 URL（包含 key 参数）
    captchaSrc.value = `${process.env.VUE_APP_BASE_API || 'http://localhost:1770'}/login/getImgCode?key=${uniqueKey}`
  } catch (err) {
    console.error('获取验证码失败:', err)
    errorMsg.value = '验证码获取失败'
  }
}
// 修改 handleLogin 函数，使用真实的登录接口
const handleLogin = async () => {
  loading.value = true;
  errorMsg.value = '';

  try {
    console.log('登录参数:', form.value)
    // 调用真实的登录接口
    const response = await signin({
      account: form.value.account,
      password: form.value.password,
      captcha: form.value.captcha,
      key: form.value.key
    });
    console.log('登录成功:', response.data.data.token)
    // 登录成功处理
    if (response && response.data.code === 200) {
      console.log('进来了吗:', response.data.code)
      // 存储 token
      localStorage.setItem('token', response.data.data.token);
      localStorage.setItem('systemAdmin', JSON.stringify(response.data.data));      // 跳转到管理首页
      router.push('/dashboard')

    } else {
      errorMsg.value = response.data.message;
      refreshCaptcha(); // 刷新验证码
    }
  } catch (err) {
    console.error('登录失败:', err);
    // 根据错误类型显示不同提示
    if (err.response && err.response.data && err.response.data.message) {
      errorMsg.value = err.response.data.message;
    } else {
      errorMsg.value = '登录失败，请重试';
    }
    refreshCaptcha(); // 登录失败刷新验证码
  } finally {
    loading.value = false;
  }
};


// 组件挂载时获取验证码
onMounted(() => {
  refreshCaptcha()
})
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.login-box {
  width: 100%;
  max-width: 400px;
  padding: 30px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;

  h2 {
    color: #333;
    margin: 0 0 10px 0;
    font-size: 24px;
  }

  p {
    color: #666;
    margin: 0;
    font-size: 14px;
  }
}

.form-group {
  margin-bottom: 20px;

  label {
    display: block;
    margin-bottom: 8px;
    color: #333;
    font-size: 14px;
    font-weight: 500;
  }

  input {
    width: 90%;
    padding: 12px 15px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
    transition: border-color 0.3s;

    &:focus {
      outline: none;
      border-color: #E6398B;
    }
  }
}

.captcha-group {
  .captcha-wrapper {
    display: flex;
    gap: 10px;
    align-items: center;

    .captcha-input {
      flex: 1;
    }

    .captcha-img {
      width: 100px;
      height: 40px;
      cursor: pointer;
      border: 1px solid #ddd;
      border-radius: 4px;
    }
  }
}

.form-actions {
  margin-top: 30px;
}

.login-btn {
  width: 100%;
  padding: 12px;
  background-color: #E6398B;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #d4287a;
  }

  &:disabled {
    background-color: #f0a0c5;
    cursor: not-allowed;
  }
}

.error-message {
  margin-top: 15px;
  color: #ff4d4f;
  font-size: 14px;
  text-align: center;
}
</style>
